import MuiAccordion, { AccordionProps } from '@mui/material/Accordion'
import MuiAccordionSummary, {
  AccordionSummaryProps,
} from '@mui/material/AccordionSummary'

import MuiAccordionDetails from '@mui/material/AccordionDetails'
import {
  ExpandMore,
  ArrowForwardIosSharp,
  KeyboardArrowRight,
  KeyboardArrowUp,
} from '@mui/icons-material'
import { styled, Typography } from '@mui/material'
import { AcordionComponentProps } from 'components/accordion/models/accordion-component-props'

const Accordion = styled((props: AccordionProps) => (
  <MuiAccordion disableGutters elevation={0} square={false} {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  '&:not(:last-child)': {
    borderBottom: 0,
  },
  '&::before': {
    display: 'none',
  },
  boxShadow: `0px 2px 5px 0px ${theme.palette.divider}`,
  borderRadius: '5px',
}))

const AccordionSummary = styled((props: AccordionSummaryProps) => (
  <MuiAccordionSummary
    // expandIcon={<ArrowForwardIosSharp sx={{ fontSize: '0.9rem' }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, .05)' : '#fff',
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(90deg)',
  },
  borderRadius: '5px',
  '& .MuiAccordionSummary-content': {
    // marginLeft: theme.spacing(1),
  },
}))

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: '1px solid rgba(0, 0, 0, .125)',
}))

const AccordionComponent = ({
  title,
  children,
  expanded,
  expandedName,
  handleChangeAccordion,
  defaultExpanded,
}: AcordionComponentProps) => (
  <Accordion
    expanded={expandedName ? expanded === expandedName : undefined}
    onChange={
      expandedName && handleChangeAccordion
        ? handleChangeAccordion(expandedName)
        : undefined
    }
    defaultExpanded={defaultExpanded}
  >
    <AccordionSummary
      aria-controls={`${expandedName}-content`}
      id={`${expandedName}-header`}
      expandIcon={<KeyboardArrowRight />}
    >
      <Typography fontSize="13px" fontWeight={600}>
        {title}
      </Typography>
    </AccordionSummary>
    <AccordionDetails>{children}</AccordionDetails>
  </Accordion>
)

export default AccordionComponent
